import { render, staticRenderFns } from "./OffersSection.vue?vue&type=template&id=3b944e1b"
import script from "./OffersSection.vue?vue&type=script&lang=js"
export * from "./OffersSection.vue?vue&type=script&lang=js"
import style0 from "./styles/action-list.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./styles/action.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports